import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router'
import { ReportsService } from '../reports/reports.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css'],
    standalone: false
})
export class ReportsComponent implements OnInit {
  dropdownValues: any;

  constructor(private router: Router,
    private reportService: ReportsService
  ) { }

  ngOnInit() {
    this.getReports();
  }
 getReports() {
  this.reportService.getDropdownForReport().subscribe((response: any) => {
    if (response["Success"] && response["Data"].length) {
      // Sort existing response data
      const sortedData = response["Data"].sort((a: any, b: any) =>
        a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' })
      );

      this.dropdownValues = sortedData;
    }
  });
}

  navigateToReports(report:any) {
    let objToSend: NavigationExtras = {
      queryParams: report,
      skipLocationChange: false,
      fragment: 'top'
    };
    this.router.navigate(['reports/reportview'], {
      state: { reportData: objToSend }
    });
  }
}
